module.exports = {
    // basic
    'read-all': 'read all',
    'company-of-user': 'company (user)',
    'user-company-or-role-type-required': 'Either company (User) or role type selection is required',
    'user-company-required': 'Company (User) selection is required',
    // raw
    // template
};
